import React from "react"
import Slider from "react-slick"

import t from "../locale"

const OfficesSliderSquareOne = ({ lang }) => {
  const officesSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    fade: true,
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          arrows: false,
        },
      },
    ],
  }

  return (
    <Slider {...officesSlider}>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>{t("Modern version (floor 2-4)", lang)}</h4>
              <p>
                1851,46{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p>148 {t("workplaces", lang)}</p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/US_One/US1_modern.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom">
            <ul>
              <li>{t("2 office rooms / 1 person", lang)}</li>
              <li>{t("Reception desk", lang)}</li>
              <li>{t("13 conference rooms", lang)}</li>
              <li>{t("Kitchen", lang)}</li>
              <li>{t("2 storage rooms", lang)}</li>
              <li>{t("Relax area", lang)}</li>
              <li>{t("7 focus rooms", lang)}</li>
              <li>{t("Team work areas", lang)}</li>
              <li>{t("Assembly hall", lang)}</li>
              <li>{t("Phone booths", lang)}</li>
              <li>{t("Coffee points", lang)}</li>
            </ul>
            <a
              href={require("../assets/pdf/UNITY-SQUARE-One-modern.pdf")}
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="offices-schema__wrapper">
          <div className="offices-schema__wrapper-top">
            <h3>{t("Sample arrangements of an office", lang)}:</h3>
            <div>
              <h4>{t("Traditional version (floor 2-4)", lang)}</h4>
              <p>
                1045,34{" "}
                <span
                  dangerouslySetInnerHTML={{ __html: t("sqm GLA", lang) }}
                />
              </p>
              <p>240 {t("workplaces", lang)}</p>
            </div>
          </div>
          <div className="img__wrapper">
            <img
              src={require("../assets/images/US_One/US1_traditional.png")}
              alt=""
            />
          </div>
          <div className="offices-schema__wrapper-bottom">
            <ul>
              <li>{t("1 office room / 1 person", lang)}</li>
              <li>{t("Reception desk", lang)}</li>
              <li>{t("9 conference rooms", lang)}</li>
              <li>{t("Kitchen", lang)}</li>
              <li>{t("1 storage room", lang)}</li>
              <li>{t("Relax area", lang)}</li>
              <li>{t("Team work areas", lang)}</li>
              <li>{t("Phone booths", lang)}</li>
              <li>{t("Assembly hall", lang)}</li>
            </ul>
            <a
              href={require("../assets/pdf/UNITY-SQUARE-One-traditional.pdf")}
              target="_blank"
              rel="noreferrer"
              className="btn-custom-back btn-custom-back--orange"
            >
              {t("Download Floor Plan", lang)}
            </a>
          </div>
        </div>
      </div>
      {/* <div>
        {lang === "en" ? (
          <img
            className="img-fluid"
            src={require("../assets/images/offices-USquare-One-en.jpg")}
            alt=""
          />
        ) : (
          <img
            className="img-fluid"
            src={require("../assets/images/offices-USquare-One-pl.jpg")}
            alt=""
          />
        )}
      </div> */}
    </Slider>
  )
}

export default OfficesSliderSquareOne
